import { createFileRoute } from "@tanstack/react-router";
import { HoursScreen } from "../components/settings/hours-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/oppettider")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <HoursScreen franchiseId={franchise.id} timezone={franchise.timezone} />;
}
